import { useCallback, useState } from 'react';
import { IDepartments } from '../../../../../interface/interfaces';
import { calculatePosition } from '../utils/calculatePosition';
import { Node } from '@xyflow/react';

export const useAddNode = (posX: number, posY: number, inDepartment: IDepartments[], outDepartment: IDepartments[], rootDepartment: IDepartments, sendWebsocketMessage: (data: string) => void) => {
    const [nodes, setNodes] = useState<Node[]>([]);

    const onAdd = useCallback(
        (node: IDepartments, num: number) => {
            const { newPosition, bgColor, borderColor } = calculatePosition(node.Type || '', num, posX, posY, inDepartment.length, outDepartment.length);

            const newNode: Node = {
                id: `${node.DepartmentId}`,
                type: 'customNode',
                data: {
                    bgColor,
                    borderColor,
                    node,
                    rootDepartment,
                    sendWebsocketMessage,
                },
                position: newPosition,
            };
            setNodes((nds) => [...nds, newNode]);
        },
        [inDepartment.length, posX, posY, outDepartment.length],
    );

    const clearNodes = useCallback(() => {
        setNodes([]);
    }, []);

    return { nodes, setNodes, onAdd, clearNodes };
};
